import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "filter mb-8" }
const _hoisted_2 = { class: "filter_top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-gray-800 fs-4 fw-bold mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Фильтр ")
], -1)
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "form-row form-row-1" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "form-row form-row-2" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_13 = { class: "form-row form-row-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Фильтровать ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Сбросить ")
const _hoisted_19 = {
  key: 0,
  class: "px-10 py-4 rounded border text-center mb-4"
}
const _hoisted_20 = {
  key: 1,
  class: "px-10 py-4 rounded border text-center my-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input_text = _resolveComponent("base-input-text")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_input_text, {
                placeholder: "Название",
                modelValue: _ctx.companiesFilterData['filter[name]'],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companiesFilterData['filter[name]']) = $event)),
                id: "name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                placeholder: "Номер телефона",
                modelValue: _ctx.companiesFilterData['filter[phone]'],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companiesFilterData['filter[phone]']) = $event)),
                id: "phone"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_base_input_text, {
                placeholder: "Введите email",
                modelValue: _ctx.companiesFilterData['filter[email]'],
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companiesFilterData['filter[email]']) = $event)),
                id: "email"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_select, {
                class: "w-100",
                placeholder: "Статус",
                options: [
                {
                  label: 'Все',
                  value: 'all',
                },
                {
                  label: 'Одобренные',
                  value: 'confirmed',
                },
                {
                  label: 'Непроверенные',
                  value: 'not_verified',
                },
                {
                  label: 'Отклонённые',
                  value: 'rejected',
                },
              ],
                modelValue: _ctx.companiesFilterData['filter[status]'],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companiesFilterData['filter[status]']) = $event)),
                id: "status"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_base_input_text, {
                placeholder: "ID юзера",
                modelValue: _ctx.companiesFilterData['filter[user_id]'],
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companiesFilterData['filter[user_id]']) = $event)),
                id: "user_id"
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: _ctx.filterCompaniesButtonClick
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "default",
              onClick: _ctx.resetFilterForm
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_el_pagination, {
            background: "",
            small: "small",
            "page-size": 10,
            "pager-count": 4,
            total: _ctx.itemsTotal,
            "current-page": _ctx.companiesFilterData.page,
            layout: "prev, pager, next",
            onCurrentChange: _ctx.paginationClick
          }, null, 8, ["total", "current-page", "onCurrentChange"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_el_pagination, {
            background: "",
            small: "small",
            "page-size": 10,
            "pager-count": 4,
            total: _ctx.itemsTotal,
            "current-page": _ctx.companiesFilterData.page,
            layout: "prev, pager, next",
            onCurrentChange: _ctx.paginationClick
          }, null, 8, ["total", "current-page", "onCurrentChange"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}